// extracted by mini-css-extract-plugin
module.exports = {"container":"SessionsList_container__2ZuYy","session":"SessionsList_session__1gjod"};